/* UPP redesign: pick matching chairs for a table (owner 2026-10-16). Shared by the product page
   (assets/upp-pdp.js) and the cart drawer. Data: the JSON array from snippets/upp-chair-match.
   window.uppChairMatch.pick(chairs, opts) -> { kind: 'pick' | 'match' | 'pairs', items: [{ chair, variant }] }
     kind 'pick': the table's own custom.recommended_chairs (chairs carry "f"): exactly those, in that
     order, however many (1-3); wood matching and opts.max don't apply.
     opts.woods:  the table's woods, lower case. Pass the variant's wood / colour option value first
                  when it has one, then custom.wood_type; the first wood that any chair shares wins.
     opts.values: the table variant's other option values, lower case (finish / colour): a chair
                  variant that shares one is preferred.
     opts.max:    how many (default 3).
   Order: same wood (else every chair, kind 'pairs' = "Pairs well"); within that, the most units in
   stock first (k, from snippets/upp-chair-match), then in stock, then the collection's order (r). Per chair: the variant sharing a finish value, else in stock, else first. */
(function () {
  'use strict';
  if (window.uppChairMatch) return;   /* loaded by both the product page and the cart drawer */
  function lc(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function variantFor(chair, values) {
    var vs = chair.v || [];
    var shared = vs.filter(function (v) { return (v.o || []).some(function (o) { return values.indexOf(o) > -1; }); });
    var pool = shared.length ? shared : vs;
    return pool.filter(function (v) { return v.s; })[0] || pool[0] || null;
  }
  function pick(chairs, opts) {
    opts = opts || {};
    var max = opts.max || 3;
    var woods = (opts.woods || []).map(lc).filter(Boolean);
    var values = (opts.values || []).map(lc).filter(Boolean);
    var list = (chairs || []).filter(function (c) { return c.v && c.v.length; });
    var picked = list.filter(function (c) { return c.f != null; });
    if (picked.length) {
      picked.sort(function (a, b) { return a.f - b.f; });
      return { kind: 'pick', items: picked.map(function (c) { return { chair: c, variant: variantFor(c, values) }; }) };
    }
    var kind = 'pairs', matched = [];
    for (var i = 0; i < woods.length && !matched.length; i++) {
      matched = list.filter(function (c) { return (c.w || []).indexOf(woods[i]) > -1; });
    }
    if (matched.length) { kind = 'match'; list = matched; }
    /* most units in stock first (k, owner 2026-10-17), then in stock, then the collection's order */
    var kOf = function (c) { return c.k != null ? c.k : c.r; };
    list = list.slice().sort(function (a, b) { return kOf(a) - kOf(b) || (b.s ? 1 : 0) - (a.s ? 1 : 0) || a.r - b.r; });
    return {
      kind: kind,
      items: list.slice(0, max).map(function (c) { return { chair: c, variant: variantFor(c, values) }; })
    };
  }
  window.uppChairMatch = { pick: pick };
})();
